<!-- DESKTOP MENU -->
<nav class="navbar navbar-expand-xl navbar-light bg-white px-0 px-xl-3" (mouseleave)="onNavLeave()">
  <div class="container-fluid p-0">
    <!-- Logo -->
    <a class="navbar-brand" [routerLink]="['/home']">
      <img src="https://intranet.ahorramas.com/wp-content/uploads/2023/04/ahora_isologo_horizontal_a_2235x1024px.jpg" class="img-fluid" width="135" height="100" alt="Logo">
    </a>

    <!-- Menú principal -->
    <div class="collapse navbar-collapse me-3">
      <ul class="navbar-nav ms-auto">
        <!-- Menú dinámico -->
        <li
          class="nav-item dropdown"
          *ngFor="let item of navItems"
          [ngClass]="{ dropdown: item.subitems && item.subitems.length }"
          (mouseenter)="onItemEnter(item)"
        >
      <a
            class="nav-link text-dark fw-bold underline-ahorramas fs-6"
            [ngClass]="{ 'dropdown-toggle': item.subitems?.length }"
            role="button"
            [attr.href]="item.url?.includes('intranet' ) ? '/intranet/' + item.post_name : item.url || '#'"
          >
            {{ item.label }}
          </a>
        </li>
      </ul>
    </div>

    <!-- Mega dropdown (único, 100% ancho) -->
    <div class="mega-dropdown" [class.visible]="isMegaOpen && (activeItem?.subitems?.length || activeItem?.customContent)">
      <div class="mega-content" *ngIf="activeItem">
        <!-- Panel de busqueda (Lupa) -->
        <ng-container *ngIf="activeItem?.customContent === 'search'; else listMode">
          <div class="search-panel w-100">
            <div class="search-hero d-flex align-items-center gap-3 mb-4">
              <img class="search-icon" src="./../../../../../assets/icons/nav-bar/lupa_off.svg" alt="Buscar">
              <input class="form-control search-title m-0" type="text" placeholder="¿Qué estás buscando?" />
            </div>

            <div class="search-suggestions">
              <div class="suggestions-title">Sugerencias de búsqueda</div>
              <ul class="suggestions-list list-unstyled mt-3">
                <li class="suggestion-item"><a href="#" class="suggestion-link">Tiendas</a></li>
                <li class="suggestion-item"><a href="#" class="suggestion-link">Aperturas</a></li>
                <li class="suggestion-item"><a href="#" class="suggestion-link">Noticias</a></li>
                <li class="suggestion-item"><a href="#" class="suggestion-link">Organización</a></li>
              </ul>
            </div>
          </div>
        </ng-container>
        <!-- Items de los dropdown -->
        <ng-template #listMode>
          <div class="mega-header text-muted small fw-thin mb-2">
            Explorar {{ activeItem?.label }}
          </div>
          <div class="mega-wrap" *ngIf="activeItem?.subitems?.length">
            <ul class="mega-first-level list-unstyled m-0">
              <li class="mega-item"
                  *ngFor="let sub of activeItem.subitems"
                  (mouseenter)="onSubEnter(sub)">
              <ng-container *ngIf="sub.post_name !== 'universo-ahorramas' && sub.post_name !== 'menu-comedor-velilla' && sub.post_name !== 'noticias'; else plainRoute"> <!--TODO ver como manejar esto no esta bien asi hardcodeado-->
                <a class="dropdown-item text-dark fw-bold" [routerLink]="['/legal', sub.post_name]">
                  {{ sub.label }}
                </a>
              </ng-container>
              <ng-template #plainRoute>
                <a class="dropdown-item text-dark fw-bold" [routerLink]="[sub.post_name]">
                 {{ sub.label }}
                </a>
              </ng-template>

              </li>
            </ul>

            <!-- Nested panel (Dropdown de dropdown) -->
            <div class="nested-panel" *ngIf="hoveredSubItem?.subitems?.length">
              <ul class="list-unstyled ">
                <li *ngFor="let third of hoveredSubItem.subitems">
                  <a class="dropdown-item text-dark fw-bold"  [routerLink]="['/noticias']"
            [queryParams]="{ category: getCategorySlug(third.url) }">
                    {{ third.label }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Iconos a la derecha -->
    <div>
      <ul class="navbar-nav d-flex flex-row align-items-center ms-auto flex-nowrap uniform-gap">
        <!-- Lupa -->
        <li class="nav-item" (mouseenter)="onSearchEnter()">
          <a class="text-dark" href="#">
            <img
              src="./../../../../../assets/icons/nav-bar/lupa_off.svg"
              alt="Búsqueda icono"
              class="nav-bar-icon"
              onmouseover="this.src='./../../../../../assets/icons/nav-bar/lupa_on.svg'"
              onmouseout="this.src='./../../../../../assets/icons/nav-bar/lupa_off.svg'"
            >
          </a>
        </li>

        <!-- Mapa -->
        <li class="nav-item">
          <a class="text-dark" href="https://www.ahorramas.com/encuentra-tu-tienda" target="_blank">
            <img
              src="./../../../../../assets/icons/nav-bar/map_off.svg"
              alt="Mapa icono"
              class="nav-bar-icon"
              onmouseover="this.src='./../../../../../assets/icons/nav-bar/map_on.svg'"
              onmouseout="this.src='./../../../../../assets/icons/nav-bar/map_off.svg'"
            >
          </a>
        </li>

        <!-- Notificaciones -->
        <li class="nav-item d-none d-md-block" (click)="onNotificationClick()">
          <img
            src="./../../../../../assets/icons/nav-bar/ring_off.svg"
            alt="Notificaciones icono"
            class="nav-bar-icon"
            onmouseover="this.src='./../../../../../assets/icons/nav-bar/ring_on.svg'"
            onmouseout="this.src='./../../../../../assets/icons/nav-bar/ring_off.svg'"
          >
          <span class="badge rounded-pill badge-notification bg-danger">1</span>
        </li>

        <!-- Información -->
        <li class="nav-item d-none d-md-block">
          <a class="text-dark" routerLink="faqs">
            <img
              src="./../../../../../assets/icons/nav-bar/question_off.svg"
              alt="Información icono"
              class="nav-bar-icon"
              onmouseover="this.src='./../../../../../assets/icons/nav-bar/question_on.svg'"
              onmouseout="this.src='./../../../../../assets/icons/nav-bar/question_off.svg'"
            >
          </a>
        </li>

        <!-- Usuario -->
        <li class="nav-item" (click)="onProfileClick()">
          <a class="text-dark">
            <img
              src="./../../../../../assets/icons/nav-bar/user_off.svg"
              alt="Usuario icono"
              class="nav-bar-icon"
              onmouseover="this.src='./../../../../../assets/icons/nav-bar/user_on.svg'"
              onmouseout="this.src='./../../../../../assets/icons/nav-bar/user_off.svg'"
            >
          </a>
        </li>

        <!-- Menú móvil -->
        <li class="menumobile nav-item d-block d-xl-none">
          <button class="btn mobile-menu-toggle" (click)="toggleMenu()">
            <i class="fas fa-bars fa-2x"></i>
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-- Blur overlay for page content when mega dropdown is open -->
<div class="blur-overlay" [class.visible]="isMegaOpen"></div>



<!-- MOBILE MENU -->
<nav class="mobile-menu" *ngIf="isMenuOpen">
  <button class="btn close-btn" (click)="toggleMenu()">
    <i style="font-weight: 300; font-style: normal; transform: scaleX(1.3); display: inline-block;" class="fa-thin fa-x fa-lg"></i>
  </button>


  <div class="d-flex flex-column justify-content-between h-100 w-100 p-4">
    <nav class="menu-options text-start mt-5">
      <ul class="navbar-nav ms-auto align-items-start">
        <li
          class="nav-item py-2 d-block w-100"
          *ngFor="let item of navItems"
        >
          <ng-container *ngIf="item.subitems?.length > 0; else noSubmenu">
            <a
              class="nav-link fw-bold titlelinks d-flex justify-content-between align-items-center w-100 text-dark"
              role="button"
              (click)="toggleMobileDropdown(item.label)">
              <span>{{ item.label }}</span>
              <i class="fa-solid fa-chevron-down"></i>
            </a>
            <ul class="dropdown-menu custom-dropdown" [class.visible]="mobileDropdowns[item.label]">
            <li *ngFor="let sub of item.subitems">
  <!-- Caso 1: sub.url contiene 'intranet' -->
  <ng-container *ngIf="sub.url?.includes('intranet'); else notIntranet">
    <a
      class="dropdown-item fw-semibold"
      [routerLink]="sub.post_name"
      (click)="toggleMenu()">
      {{ sub.label }}
    </a>
  </ng-container>

  <!-- Caso 2 y 3: no contiene 'intranet' -->
  <ng-template #notIntranet>
    <ng-container *ngIf="!isExternal(sub.url); else externalLink">
      <!-- Caso 2: ruta interna con routerLink -->
      <a
        class="dropdown-item fw-semibold"
        [routerLink]="['/', sub.post_name]"
        (click)="toggleMenu()">
        {{ sub.label }}
      </a>
    </ng-container>

    <!-- Caso 3: enlace externo -->
    <ng-template #externalLink>
      <a
        class="dropdown-item fw-semibold"
        [href]="sub.url"
        target="_blank"
        rel="noopener noreferrer"
        (click)="toggleMenu()">
        {{ sub.label }}
      </a>
    </ng-template>
  </ng-template>
</li>

            </ul>
          </ng-container>
          <ng-template #noSubmenu>
            <a
              class="nav-link text-dark fw-bold titlelinks"
              [href]="item.url"
              (click)="toggleMenu()"
              [attr.target]="isExternal(item.url) ? '_blank' : null">
              {{ item.label }}
            </a>
          </ng-template>
        </li>
      </ul>

    </nav>

  <div class="d-flex justify-content-around text-black">
  <a
    *ngFor="let rrssItem of rrss"
    class="d-block mb-3 text-black fw-bold fs-4"
    [href]="rrssItem.url"
    target="_blank"
    (click)="toggleMenu()"
  >
     <i class="fa-brands fa-lg social-icon me-2" [ngClass]="'fa-' + rrssItem.action"></i>
  </a>
</div>

  </div>
</nav>



